import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/ui/card";
import { Badge } from "./ui/ui/badge";
import { Clock, Code, Coffee, MapPin, Calendar } from "lucide-react";
import { cn } from "../lib/utils";

const Schedule: React.FC = () => {
  const scheduleItems = [
    {
      time: "6:00pm - 8:00pm",
      event: "Tech Party",
      description: "Drinks, music, and meeting cool people in Austin's AI space",
      icon: Coffee,
      color: "text-neon-blue"
    }
  ];

  return (
    <div className="min-h-screen py-20 px-4">
      <div className="container max-w-4xl mx-auto space-y-12">
        {/* Header */}
        <div className="text-center space-y-4">
          <Badge variant="outline" className="border-primary text-primary">
            <Calendar className="h-3 w-3 mr-1" />
            Event Schedule
          </Badge>
          <h1 className="text-4xl lg:text-5xl font-bold font-mono text-primary">
            ./schedule --list
          </h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            An unstructured social evening to connect with Austin's AI community
          </p>
        </div>

        {/* Event Info */}
        <Card className="bg-card/30 backdrop-blur-sm border-border/50">
          <CardHeader>
            <CardTitle className="font-mono text-primary flex items-center space-x-2">
              <Clock className="h-5 w-5" />
              <span>event.details</span>
            </CardTitle>
            <CardDescription>Next meetup information</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center space-x-3 text-sm">
              <Calendar className="h-4 w-4 text-primary" />
              <span className="font-semibold text-foreground">Date:</span>
              <span className="text-muted-foreground">July 10th, 2025</span>
            </div>
            <div className="flex items-center space-x-3 text-sm">
              <Clock className="h-4 w-4 text-primary" />
              <span className="font-semibold text-foreground">Time:</span>
              <span className="text-muted-foreground">6:00pm - 8:00pm CST</span>
            </div>
            <div className="flex items-center space-x-3 text-sm">
              <MapPin className="h-4 w-4 text-primary" />
              <span className="font-semibold text-foreground">Location:</span>
              <span className="text-muted-foreground">1705 Guadalupe St. at DeAI Office</span>
            </div>
          </CardContent>
        </Card>

        {/* Schedule */}
        <Card className="bg-card/30 backdrop-blur-sm border-border/50">
          <CardHeader>
            <CardTitle className="font-mono text-primary flex items-center space-x-2">
              <Code className="h-5 w-5" />
              <span>$ cat agenda.txt</span>
            </CardTitle>
            <CardDescription>Planned activities and timeline</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {scheduleItems.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div 
                    key={index} 
                    className="flex items-start space-x-4 p-4 rounded-lg bg-card/20 border border-border/30 hover:border-primary/50 transition-all duration-300"
                  >
                    <div className="flex-shrink-0">
                      <IconComponent className={cn("h-5 w-5", item.color)} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center space-x-3 mb-1">
                        <span className="font-mono text-sm font-semibold text-primary">
                          {item.time}
                        </span>
                        <span className="text-foreground font-medium">
                          {item.event}
                        </span>
                      </div>
                      <p className="text-sm text-muted-foreground">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>

        {/* Refreshments */}
        <Card className="bg-card/30 backdrop-blur-sm border-border/50">
          <CardHeader>
            <CardTitle className="font-mono text-primary flex items-center space-x-2">
              <Coffee className="h-5 w-5" />
              <span>$ ls refreshments/</span>
            </CardTitle>
            <CardDescription>What we provide</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              {["pizza.txt", "party_drinks.bin", "snacks.json", "coffee.exe"].map((item, index) => (
                <div key={index} className="p-3 rounded-lg bg-card/20 border border-border/30">
                  <span className="font-mono text-sm text-muted-foreground">
                    {item}
                  </span>
                </div>
              ))}
            </div>
            <p className="text-xs text-muted-foreground text-center mt-4">
              Refreshments provided • Dietary restrictions accommodated
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Schedule;